import Entity, { TEntity } from '@/plugins/podolib/services/entities/Entity';

import {
  AnalysisRunningMode,
  AnalysisType,
  AnalysisWalkingMode,
} from '@/components/analysis/steps/type/AnalysisStepType';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';
import { TSoles } from '@/plugins/podolib/services/entities/EntitySoles';
import { StepConditions } from '@/components/analysis/steps/conditions/AnalysisStepConditions';

export enum CommandStatus {
  Sent = 'sent',
  Received = 'received',
  Pending = 'pending',
  Completed = 'completed',
  Error = 'error',
}

export enum CommandStep {
  Scanning = 'scanning',
  Connecting = 'connecting',
  Starting = 'starting',
  Started = 'started',
  Completed = 'completed',
  Stopping = 'stopping',
  GettingData = 'getting_data',
}

export enum CommandName {
  StartAcquisition = 'start acquisition',
  AcquisitionData = 'acquisition data',
}

export type CommandError = {
  name: string;
  code: number;
  description: string;
};

export type TCommandSettingsParamsMems = {
  gyroscope: {
    config_flags: {
      CTRL7_G_G_HM_MODE: number;
    };
  };
  accelerometer: {
    full_scale: number;
    config_flags: {
      CTRL6_C_XL_HM_MODE: number;
    };
  };
};

export type CommandSettings = {
  patientId: string;
  stationId: string;
  solesId: string;
  data: {
    analysisType: AnalysisType;
    analysisMode: AnalysisRunningMode | AnalysisWalkingMode | null;
    mode: 'standard' | 'segmented' | null;
    treadmill_speed?: number | null;
    observation?: string;
    params?: {
      aqDelay: number | null;
      aqDuration: number | null;
      memsConfig?: TCommandSettingsParamsMems;
    };
    conditions: StepConditions;
    step?: CommandStep;
    progress?: number;
    error?: {
      code?: number;
    };
  };
};

export type TCommand = CommandSettings & {
  command: CommandName;
  status?: CommandStatus;
};

export default class EntityCommands extends Entity<any> {
  name: string = 'commands';
  public get mutations() {
    return {
      ...super.mutations,
      ...{
        CLEAR(state: any) {
          state.list = [];
        },
      },
    };
  }
  removeAcquisitionCommands() {
    let commands = this.Vue.prototype.$pdc.entities[this.name].storedEntity.list;
    for (const command of commands) {
      this.Vue.prototype.repository?.socket?.deleteCommand(command._id);
      this.Vue.prototype.$pdc.entities[this.name].remove(command._id);
    }
    this.Vue.prototype.$pdc.acquisition.resetAcquisitionInProgress();
    this.Vue.prototype.$pdc.acquisition.resetAcquisition();
    this.Vue.prototype.$pdc.acquisition.resetTimer();
  }
}
